import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ArrowRight, Home, Search } from 'lucide-react';
import AnimatedSection from '../components/AnimatedSection';

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page Not Found | YN Dream Curtains Adelaide</title>
        <meta name="description" content="The page you're looking for doesn't exist. Browse our custom curtains, blinds & shutters in Adelaide." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', padding:'120px 20px 80px', background:'var(--bg)' }}>
        <AnimatedSection style={{ textAlign:'center', maxWidth:600 }}>
          <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:'8rem', fontWeight:700, color:'var(--gold-pale)', lineHeight:1, marginBottom:8 }}>404</div>
          <div className="section-label" style={{ justifyContent:'center' }}>Page Not Found</div>
          <h1 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:'2.4rem', fontWeight:600, color:'var(--text)', marginBottom:14, lineHeight:1.1 }}>
            This Page Doesn't <em style={{ color:'var(--gold)' }}>Exist</em>
          </h1>
          <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize:'1.05rem', color:'var(--text-dim)', lineHeight:1.75, marginBottom:36 }}>
            The page you're looking for may have been moved or no longer exists. Let us help you find what you need.
          </p>
          <div style={{ display:'flex', gap:14, justifyContent:'center', flexWrap:'wrap' }}>
            <Link to="/" className="btn-primary"><Home size={14}/> Back to Home</Link>
            <Link to="/products" className="btn-secondary"><Search size={14}/> Browse Products</Link>
          </div>
          <div style={{ marginTop:40, padding:'24px 28px', background:'var(--bg-warm)', border:'1px solid var(--border-soft)', boxShadow:'var(--shadow-sm)' }}>
            <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize:'0.88rem', color:'var(--text-dim)', marginBottom:12, lineHeight:1.6 }}>
              Looking for curtains, blinds or shutters in Adelaide? Visit these pages:
            </p>
            <div style={{ display:'flex', flexWrap:'wrap', gap:8, justifyContent:'center' }}>
              {[
                { to:'/products', label:'Our Products' },
                { to:'/portfolio', label:'Our Portfolio' },
                { to:'/book-online', label:'Book Consultation' },
                { to:'/contact', label:'Contact Us' },
              ].map(l => (
                <Link key={l.to} to={l.to} style={{ fontFamily:"'DM Sans',sans-serif", fontSize:'0.84rem', color:'var(--gold)', textDecoration:'none', border:'1px solid var(--border-soft)', padding:'6px 14px', background:'var(--bg-card)', transition:'all 0.3s' }}>
                  {l.label} <ArrowRight size={11} style={{ verticalAlign:'middle' }} />
                </Link>
              ))}
            </div>
          </div>
        </AnimatedSection>
      </div>
    </>
  );
}
